import { SpinnerIcon } from "../lib/icons.js";

export function Spinner({ size = 20, label }: { size?: number; label?: string }): JSX.Element {
  return (
    <div className="inline-flex items-center gap-2 text-zinc-500">
      <SpinnerIcon size={size} />
      {label && <span className="text-sm">{label}</span>}
    </div>
  );
}

export function LoadingBlock({ label = "Načítám…" }: { label?: string }): JSX.Element {
  return (
    <div className="flex items-center justify-center py-16">
      <Spinner size={24} label={label} />
    </div>
  );
}
